import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import axios from "axios";
import { IoCloseOutline } from "react-icons/io5";
import { getAssetUrl } from "./loginDisplayUtil";

const CustomerPdpa = ({ show, setShow, setError, setShowError }) => {
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");

    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { lanIndex, token, userId, company, bgImg } = React.useContext(UserContext);

    const [pdpa, setPdpa] = useState("");

    useEffect(() => {
        setDisplay(show ? "flex" : "none");
        if (token && userId && show) {
            axios.get(`/v2/api/customer/pdpa`, {
                headers: { Authorization: "Bearer " + token },
            })
                .then(function (response) {
                 
                    if (response.status === 200) {
                        setPdpa(response.data.pdpa || "");
                    }

                })
                .catch(function (response) {
                    //show warning
                 
                    setError([{ errorMessage: "Something went wrong. Please try again" }]);
                    setShowError(true);
                })

            
        }
    }, [show, token, userId, setError, setShowError]);

    return (
        <React.Fragment>
            <ModalContainer display={displayShow} bgImg={bgImg} themeContext={themeContext}>
                <DialogSurface bgImg={bgImg} themeContext={themeContext}>
                    <IconButton onClick={() => {
                        setShow(false);
                        setDisplay("none");
                    }}>
                        <IoCloseOutline size={34} />
                    </IconButton>
                    <ContentWrapper>
                        <FormSection>
                            <ImgWrapper image={company && company.companyLogo} />
                            <TitleText>PDPA POLICY</TitleText>
                            <PolicyPanel>
                                <PolicyContent dangerouslySetInnerHTML={{ __html: pdpa }} />
                            </PolicyPanel>
                            <Button onClick={() => {
                                setShow(false);
                            }}>
                                {languageContext[lanIndex].ok}
                            </Button>
                        </FormSection>
                    </ContentWrapper>
                </DialogSurface>
            </ModalContainer>
        </React.Fragment >
    );
}

export default CustomerPdpa;

const DialogSurface = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    min-height: 100%;
    flex-direction: column;

    @media (min-width: 768px) {
        width: min(680px, 100%);
        min-height: 0;
        max-height: calc(100dvh - 64px);
        background-color: ${(props) => props.themeContext.backgroundColor};
        background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border: 1px solid rgba(255, 255, 255, 0.72);
        border-radius: 24px;
        box-shadow: 0 28px 80px rgba(15, 23, 42, 0.32);
        overflow: hidden;
        animation: customerPdpaDialogIn 220ms cubic-bezier(0.22, 1, 0.36, 1);

        @keyframes customerPdpaDialogIn {
            from {
                opacity: 0;
                transform: translateY(18px) scale(0.98);
            }
            to {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }
    }
`;

const Button = styled.div`
    display: flex;
    width: 68%;
    max-width: 360px;
    min-height: 62px;
    margin: 22px auto 0;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 400;
    border-radius: 34px;
    background-color: #5f5f5f;
    color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;

    @media (max-height: 760px) {
        min-height: 54px;
        font-size: 21px;
    }
`;

const ImgWrapper = styled.div`
    width: 220px;
    max-width: 78%;
    height: 110px;
    margin: 0 0 20px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 180px;
        height: 88px;
        margin-bottom: 14px;
    }
`;

const IconButton = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 99;
    color: #555555;
    cursor: pointer;
`;

const TitleText = styled.div`
    margin-bottom: 28px;
    color: #333333;
    font-size: 30px;
    font-weight: 300;
    line-height: 1;
    text-align: center;

    @media (max-height: 760px) {
        margin-bottom: 20px;
        font-size: 26px;
    }
`;

const PolicyPanel = styled.div`
    width: 100%;
    max-height: 48dvh;
    border-radius: 12px;
    border: 1px solid #9d9d9d;
    padding: 20px 22px;
    background-color: rgba(255,255,255,0.94);
    color: #343434;
    box-sizing: border-box;
    overflow-y: auto;
`;

const PolicyContent = styled.div`
    &, * {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    font-size: 16px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;

    p {
        margin: 0 0 12px;
    }

    *:last-child {
        margin-bottom: 0;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 44px 32px 34px;
    overflow-y: auto;

    @media (max-height: 760px) {
        padding-top: 28px;
    }

    @media (min-width: 768px) {
        min-height: 0;
        padding: 42px 40px 34px;
    }
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    padding-top: 16px;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    font-family: "contralto-xsmall", sans-serif;
    position: fixed;
    flex-direction: column;
    background-color: ${(props) => props.themeContext.backgroundColor};
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    left: max(0px, calc((100vw - 550px) / 2));

    width: 100vw;
    max-width: 550px;
    height: 100vh;
    height: 100dvh;
    z-index: 1100;

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    animation: modalOrder .1s;
    animation-timing-function: ease-out;

    @media (min-width: 768px) {
        left: 0;
        width: 100vw;
        max-width: none;
        padding: 32px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        background-color: rgba(15, 23, 42, 0.58);
        background-image: none;
        backdrop-filter: blur(6px);
        z-index: 1100;
        animation: customerPdpaBackdropIn 180ms ease-out;

        @keyframes customerPdpaBackdropIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    }

    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }
  `;

